import { render, staticRenderFns } from "./ChangeAvatarModal.vue?vue&type=template&id=3f8de1e6&scoped=true"
import script from "./ChangeAvatarModal.vue?vue&type=script&lang=js"
export * from "./ChangeAvatarModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f8de1e6",
  null
  
)

export default component.exports